import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-film-line", title: "剧集资料库", desc: "覆盖正传、衍生与相关仙侠剧的完整资料" },
  { icon: "ri-user-star-line", title: "角色详解", desc: "主要角色形象与人物弧光深度解读" },
  { icon: "ri-newspaper-line", title: "资讯更新", desc: "剧情解读、角色访谈与官方动态同步" },
];

export default function AboutStrip() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-7 p-6 md:p-10">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-accent-700 uppercase">
              <span className="w-6 h-px bg-accent-400"></span>
              About
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              关于仙剑奇侠传影视站
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              本站专注于仙剑奇侠传及经典仙侠影视作品的内容聚合，为剧迷提供剧集详情、剧情介绍、角色分析、
              最新资讯与剧集推荐，帮助每一位仙侠爱好者找回心中那段永不褪色的江湖记忆。
            </p>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {highlights.map((item) => (
                <div key={item.title} className="flex items-start gap-3">
                  <span className="w-10 h-10 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-xl shrink-0">
                    <i className={item.icon}></i>
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">
                      {item.title}
                    </span>
                    <span className="block text-xs text-foreground-500 mt-1 leading-relaxed">
                      {item.desc}
                    </span>
                  </span>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-700 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="lg:col-span-5 relative min-h-[240px] lg:min-h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20illustration%2C%20ancient%20jade-green%20pavilion%20among%20misty%20mountains%20with%20pale%20gold%20glowing%20lanterns%20at%20dusk%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=900&height=1000&seq=about-strip&orientation=portrait"
              alt="仙侠山门意境图"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-transparent to-transparent lg:from-background-50/80"></div>
          </div>
        </div>
      </div>
    </section>
  );
}